import { PersonasEditDrawer, personasEditDrawerSchema } from '../journey/detail/detailView/widgets/personas/PersonasEditDrawer';
import { TestDrawer, testDrawerSchema } from './TestDrawer';
import { JSXElementConstructor } from 'react';
import { z } from 'zod';
import { TagsEditDrawer, tagsEditDrawerSchema } from '../journey/detail/detailView/widgets/tags/TagsEditDrawer';
import { LinksEditDrawer, linksEditDrawerSchema } from '../journey/detail/detailView/widgets/links/LinksEditDrawer';
import { DurationEditDrawer, durationEditDrawerSchema } from '../journey/detail/detailView/widgets/duration/DurationEditDrawer';
import { DescriptionEditDrawer, descriptionEditDrawerSchema } from '../journey/detail/detailView/widgets/description/DescriptionEditDrawer';
import { OwnerEditDrawer, ownerEditDrawerSchema } from '../journey/detail/detailView/widgets/owner/OwnerEditDrawer';
import { NameEditDrawer, nameEditDrawerSchema } from '../journey/detail/detailView/widgets/name/NameEditDrawer';
import { JourneyEditDrawer, journeyEditDrawerSchema } from '../journey/detail/JourneyEditDrawer';
import { EditMetricDrawer, editMetricDrawerSchema } from '../connections/metrics/EditMetricDrawer';
import { PhaseEditDrawer, phaseEditDrawerSchema } from '../journey/utils/PhaseEditDrawer';
import { PersonaDetailEditDrawer, personaDetailEditDrawerSchema } from '../persona/detail/PersonaDetailEditDrawer';
import { EditMetricWidgetDrawer, editMetricWidgetDrawerSchema } from '../journey/detail/detailView/widgets/metrics/EditMetricWidgetDrawer';
import { PicturesEditDrawer, picturesEditDrawerSchema } from '../journey/detail/detailView/widgets/pictures/PictureEditDrawer';
import {
	OpportunityEditDrawer,
	opportunityEditDrawerSchema,
} from '../journey/detail/detailView/widgets/opportunities/OpportunityEditDrawer';
import { NotesEditDrawer, notesEditDrawerSchema } from '../journey/detail/detailView/widgets/notes/NotesEditDrawer';
import {
	GoalsAndObjectivesEditDrawer,
	goalsAndObjectivesEditDrawerSchema,
} from '../journey/detail/detailView/widgets/goalsAndObjectives/GoalsAndObjectivesEditDrawer';
import { JourneyFilterDrawer, journeyFilterDrawerSchema } from '../journey/JourneyFilterDrawer';
import {
	SubactivitiesEditDrawer,
	subactivityEditDrawerSchema,
} from '../journey/detail/detailView/widgets/subactivities/SubactivitiesEditDrawer';
import { ActionEditDrawer, actionEditDrawerSchema } from '../journey/detail/detailView/widgets/actions/ActionEditDrawer';
import { OpportunityFilterDrawer, opportunityFilterDrawerSchema } from '../opportunities/list/OpportunityFilterDrawer';
import { ActionFilterDrawer, actionFilterDrawerSchema } from '../actions/list/ActionFilterDrawer';
import { OrderDashboardMetricsDrawer, orderDashboardMetricsDrawerProps } from '../dashboard/OrderDashboardMetricsDrawer';
import { SummaryDrawer, summaryDrawerSchema } from '../journey/summary/SummaryDrawer';

type Def<Props> = Readonly<{
	component: JSXElementConstructor<Props>;
	payload: z.Schema<Props>;
}>;

const drawerDefinitions = {
	test: {
		component: TestDrawer,
		payload: testDrawerSchema,
	},
	editPersonas: {
		component: PersonasEditDrawer,
		payload: personasEditDrawerSchema,
	},
	editTags: {
		component: TagsEditDrawer,
		payload: tagsEditDrawerSchema,
	},
	editLinks: {
		component: LinksEditDrawer,
		payload: linksEditDrawerSchema,
	},
	editDuration: {
		component: DurationEditDrawer,
		payload: durationEditDrawerSchema,
	},
	editDescription: {
		component: DescriptionEditDrawer,
		payload: descriptionEditDrawerSchema,
	},
	editOwner: {
		component: OwnerEditDrawer,
		payload: ownerEditDrawerSchema,
	},
	editName: {
		component: NameEditDrawer,
		payload: nameEditDrawerSchema,
	},
	editJourney: {
		component: JourneyEditDrawer,
		payload: journeyEditDrawerSchema,
	},
	editMetric: {
		component: EditMetricDrawer,
		payload: editMetricDrawerSchema,
	},
	editPhase: {
		component: PhaseEditDrawer,
		payload: phaseEditDrawerSchema,
	},
	editPersonaDetail: {
		component: PersonaDetailEditDrawer,
		payload: personaDetailEditDrawerSchema,
	},
	editMetricWidget: {
		component: EditMetricWidgetDrawer,
		payload: editMetricWidgetDrawerSchema,
	},
	editPictures: {
		component: PicturesEditDrawer,
		payload: picturesEditDrawerSchema,
	},
	editOpportunity: {
		component: OpportunityEditDrawer,
		payload: opportunityEditDrawerSchema,
	},
	editAction: {
		component: ActionEditDrawer,
		payload: actionEditDrawerSchema,
	},
	editNotes: {
		component: NotesEditDrawer,
		payload: notesEditDrawerSchema,
	},
	editGoalsAndObjectives: {
		component: GoalsAndObjectivesEditDrawer,
		payload: goalsAndObjectivesEditDrawerSchema,
	},
	journeyFilter: {
		component: JourneyFilterDrawer,
		payload: journeyFilterDrawerSchema,
	},
	editActivities: {
		component: SubactivitiesEditDrawer,
		payload: subactivityEditDrawerSchema,
	},
	opportunityFilter: {
		component: OpportunityFilterDrawer,
		payload: opportunityFilterDrawerSchema,
	},
	actionFilter: {
		component: ActionFilterDrawer,
		payload: actionFilterDrawerSchema,
	},
	reorderMetrics: {
		component: OrderDashboardMetricsDrawer,
		payload: orderDashboardMetricsDrawerProps,
	},
	journeySummary: {
		component: SummaryDrawer,
		payload: summaryDrawerSchema,
	},
} as const satisfies { [key: string]: Def<any> };

export type DrawerKeys = keyof typeof drawerDefinitions;

export { drawerDefinitions };
